import React from 'react';
import useMobile from "../../../shared/hooks/useMobile";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './section-caretakers-features.scss'
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const SectionCaretakersFeatures = ({ contentInfo }) => {

    const mobile = useMobile()
    const { homeLink } = useHomeLinkMode();

    const description = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-m-caretakers-features__text-paragraph">{next}</p>,
            [INLINES.HYPERLINK]: (node, next) => <a className="f-m-caretakers-features__text-link" href={(node.data.uri.includes('https') || node.data.uri.includes('www')) ? (node.data.uri) : (homeLink + node.data.uri)} rel="noopener noreferrer" target="_blank">{next}</a>
        }
    };
    const itemList = contentInfo.listaContenidos.map((info, index) => {        
    return (
            <div key={index} className="f-m-caretakers-features__feature">
                <div className="f-m-caretakers-features__feature-content">
                    <div className="f-m-caretakers-features__image-container">
                        <img
                            src={info.imagen[0].file.url}
                            alt={info.imagen[0].description}
                        />
                    </div>
                    <div className="f-m-caretakers-features__text">
                        {
                            info.descripcion && info.descripcion.raw && 
                            documentToReactComponents(JSON.parse(info.descripcion.raw), description)
                        }
                    </div>
                </div>
            </div>
        )
    })
    return (
        <section className="f-m-caretakers-features">
            <div className="f-m-caretakers-features__content">
                {!mobile ?
                    <div className="f-m-caretakers-features__features-container">
                        {itemList}
                    </div>                    
                    :
                    <div className="f-m-caretakers-features__slider-container">
                        {itemList}                        
                    </div>                   
                }
            </div>
        </section>
    )
}

export default SectionCaretakersFeatures
